import React from 'react';
import {Route} from 'react-router-dom';
import loadable from '@loadable/component';
import {EzAppLayout} from '@ezcater/recipe';

import {useEnvironment} from './Environment';
import {EzManageNavRoute, EzManageNavSwitch} from './EzManageNav';
import {
  DELIVERY_MANAGEMENT_DELIVERIES_PATH,
  DELIVERY_MANAGEMENT_DRIVERS_PATH,
  DELIVERY_MANAGEMENT_EDIT_DRIVER_PATH,
  DELIVERY_MANAGEMENT_NEW_DRIVER_PATH,
  DELIVERY_MANAGEMENT_REPORTING_PATH,
  DELIVERY_PERFORMANCE_REPORTING_PATH,
} from '../paths';
import {CurrentAccountStoresProvider} from './DeliveryManagement';

const Deliveries = loadable(() => import('../pages/DeliveryManagement/Deliveries'));
const DriverEdit = loadable(() => import('../pages/DeliveryManagement/DriverEdit'));
const Drivers = loadable(() => import('../pages/DeliveryManagement/Drivers'));

const RoutesContainer = () => {
  const {appHost} = useEnvironment();
  const deliveryPerformanceReportingUrl = `${appHost}${DELIVERY_PERFORMANCE_REPORTING_PATH}`;

  return (
    <CurrentAccountStoresProvider>
      <Route exact path={[DELIVERY_MANAGEMENT_DELIVERIES_PATH, '/']} component={Deliveries} />
      <Route exact path={DELIVERY_MANAGEMENT_DRIVERS_PATH} component={Drivers} />
      <Route
        exact
        path={[DELIVERY_MANAGEMENT_EDIT_DRIVER_PATH, DELIVERY_MANAGEMENT_NEW_DRIVER_PATH]}
        component={DriverEdit}
      />
      <Route
        exact
        path={DELIVERY_MANAGEMENT_REPORTING_PATH}
        render={() => {
          if (typeof window !== 'undefined') {
            window.location.replace(deliveryPerformanceReportingUrl);
          }

          return null;
        }}
      />
    </CurrentAccountStoresProvider>
  );
};

const DeliveryManagementRoutes = () => {
  return (
    <EzAppLayout>
      <EzManageNavSwitch appName="DELIVERY">
        <EzManageNavRoute path="/" component={RoutesContainer} />
      </EzManageNavSwitch>
    </EzAppLayout>
  );
};

export default DeliveryManagementRoutes;
